import { api, cachedRequest } from '../apiClient';

export const addonService = {
  getAddonDetail: async (addonId: number, forceRefresh: boolean = false) => {
    const cacheKey = `addon_detail_${addonId}`;
    
    return cachedRequest(
      cacheKey,
      async () => {
        if (process.env.NODE_ENV === 'development') {
          console.log(`Making API request to /addons/${addonId}/ for addon details`);
        }
        const response = await api.get(`/addons/${addonId}/`);
        if (process.env.NODE_ENV === 'development') {
          console.log('Addon Detail API response received:', {
            addonId: response.data.id,
            addonName: response.data.name,
            hasVariants: response.data.has_variants,
            variantsCount: response.data.variants?.length || 0
          });
        }
        return response.data;
      },
      5 * 60 * 1000, // 5 minutes
      forceRefresh
    );
  },

  getEventAddons: async (eventSlug: string, params: {
    cluster?: string;
    addon_type?: string;
    include_hidden?: boolean;
  } = {}, forceRefresh: boolean = false) => {
    const queryParams = new URLSearchParams();
    if (params.cluster) queryParams.append('cluster', params.cluster);
    if (params.addon_type) queryParams.append('addon_type', params.addon_type);
    if (params.include_hidden) queryParams.append('include_hidden', 'true');
    
    const cacheKey = `event_addons_${eventSlug}_${queryParams.toString()}`;
    
    return cachedRequest(
      cacheKey,
      async () => {
        if (process.env.NODE_ENV === 'development') {
          console.log(`Making API request to /events/${eventSlug}/addons/ for event addons`);
        }
        const response = await api.get(`/events/${eventSlug}/addons/?${queryParams.toString()}`);
        if (process.env.NODE_ENV === 'development') {
          console.log('Event Addons API response received:', {
            eventSlug: response.data.event?.slug,
            addonsCount: response.data.addons?.length || 0,
            clustersCount: response.data.clusters?.length || 0
          });
        }
        return response.data;
      },
      2 * 60 * 1000, // 2 minutes
      forceRefresh
    );
  },

  // Note: Add to cart is handled through the cart service
  // Use apiService.cart.addToCart('addon', addonId, quantity, { variant_id: variantId })
};

